var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"16a92cf92ecb7383ee72a316314227f8e9f967e6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["aspen@rove-xf"]={id:"16a92cf92ecb7383ee72a316314227f8e9f967e6"};
      